import { render, staticRenderFns } from "./elevatorSelector.vue?vue&type=template&id=7f5ffbec&scoped=true&"
import script from "./elevatorSelector.vue?vue&type=script&lang=js&"
export * from "./elevatorSelector.vue?vue&type=script&lang=js&"
import style0 from "./elevatorSelector.vue?vue&type=style&index=0&id=7f5ffbec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5ffbec",
  null
  
)

export default component.exports